import { render, staticRenderFns } from "./PrivateEvents.vue?vue&type=template&id=4f17ee5b&scoped=true&"
import script from "./PrivateEvents.vue?vue&type=script&lang=js&"
export * from "./PrivateEvents.vue?vue&type=script&lang=js&"
import style0 from "./PrivateEvents.vue?vue&type=style&index=0&id=4f17ee5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f17ee5b",
  null
  
)

export default component.exports